import { Context } from '@nuxt/types';
import { Data } from '@root/modules/issue/types/issue';
import issueUrl from '@root/modules/issue/utils/buildIssueUrl';
import matchChannel from '@root/common/utils/matchChannel';

const errorMessage = {
  message: 'issue.error.not_found',
  statusCode: 404,
};

const getIssuePath = async (context: Context) => {
  const { error, store } = context;

  try {
    const { issue }: { issue: Data } = store.getters['issue/getTempData'];

    if (issue) {
      const { domain, locale, temporaryAllowedDomains } = context.app.$channelConfig('settings');
      const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;

      const sameChannel = matchChannel(domains, issue.channel.domain);

      // handle internal current channel urls or if issue doesn't belong to current channel
      if (!sameChannel) {
        const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;
        return issueUrl({ issue, locale, domain, fakeDomainEnabled });
      }
    } else {
      error(errorMessage);
    }
  } catch (e) {
    error(errorMessage);
  }

  return false;
};

export default getIssuePath;
